import React, { useContext, useState } from 'react';
import { DropDown, Input, DateControl, InputFile, RadioButton } from '../components'
import { DataContext } from '../data/DataContext';
import { catSiNo, catCICACReasonRejection } from '../data/MochaData'

const Step2 = () => {
    const { AutoEmisionCR, setAutoEmisionCR, ChangeHandler } = useContext(DataContext);
    const onChange = (property: string, value: string) => setAutoEmisionCR({ ...AutoEmisionCR, [property]: value });

    return (
        <>
            <RadioButton
                label='¿Es el cliente sujeto obligado de inscripción ante SUGEF según los artículos 15 y 15 bis de la Ley 8204?'
                field={'obligatedSubjectsPEPQuestion1'}
                key={'obligatedSubjectsPEPQuestion1'}
                value={AutoEmisionCR.obligatedSubjectsPEPQuestion1}
                onChange={() => { }}
                onChangeStr={onChange}
                catalog={catSiNo}
            />
            <RadioButton
                label='¿Ocupa o ha ocupado el cliente o su cónyuge un cargo público en los últimos 12 años? ¿En caso afirmativo, favor detalle el cargo, el período?'
                field={'obligatedSubjectsPEPQuestion2'}
                key={'obligatedSubjectsPEPQuestion2'}
                value={AutoEmisionCR.obligatedSubjectsPEPQuestion2}
                onChange={() => { }}
                onChangeStr={onChange}
                catalog={catSiNo}
            />

            <div style={{ background: '#D9D9D9', marginTop: 35, fontWeight: 600, height: 30 }}>
                <div style={{ display: "flex", justifyContent: 'center', height: '100%', alignItems: 'center', color: '#4D4D4D' }}>
                    INFORMACIÓN CICAC
                </div>
            </div>
            <p style={{ textAlign: 'justify', color: '#4D4D4D', lineHeight: '23px' }}>
                El Cliente, manifiesta conocer y aceptar en forma expresa, que ha recibido información necesaria y explicación previa, respecto al objeto, alcance, funcionamiento, acceso y uso de la información del Centro de Información Conozca a su Cliente (CICAC). Que este constituye un expediente electrónico que recopila y almacena la información como insumo básico para la atención de la política conozca a su cliente, Asimismo, declara entender, que los sujetos obligados, supervisados por las superintendencias adscritas en el Consejo Nacional de Supervisión del Sistema Financiero (CONASSIF), pueden tener acceso al CICAC, siempre y cuando exista una autorización previa por
                parte del titular de la información, Por lo tanto:
            </p>
            <RadioButton
                label='¿En su condición de cliente y titular de la información, acepta que su información sea inclinada en el centro de información conozca a su cliente (CICAC) En caso negativo favor indicar el motivo'
                field={'cICACQuestion1'}
                key={'cICACQuestion1'}
                value={AutoEmisionCR.cICACQuestion1}
                onChange={() => { }}
                onChangeStr={onChange}
                catalog={catSiNo}
            />
            {AutoEmisionCR.cICACQuestion1 === 'N' &&
                <DropDown
                    dataProvider={catCICACReasonRejection}
                    field='cICACReasonRejection'
                    label='Favor indicar el motivo de rechazo'
                    onChangeSelect={onChange}
                    valueSelect='cICACReasonRejection'
                    id='cICACReasonRejection'
                />
            }

        </>
    )
}

export { Step2 }